import React from 'react';

const GameAlert = ({ title = "", children }) => {
  return (
    <div className="max-w-2xl mx-auto mt-8 border rounded-xl p-6 shadow-lg mb-4 bg-gray-700 border-primary-600/20">
      {title && (
        <h2 className="text-2xl font-bold mb-2 bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
          {title}
        </h2>
      )}
      <div className="text-gray-300">
        {children}
      </div>
    </div>
  );
};

export default GameAlert
